<template>
  <div class="launch">
    <h1>This is an launch page</h1>
    <div>code: {{$route.params.code}} </div>
    <div>engine: {{$route.params.engine}} </div>
  </div>
</template>



<script>
export default {
  created: function () {
    // save jwt token and backend url to vuex
    let payload = {code: this.$route.params.code, engine:this.$route.params.engine}
    this.$store.commit('initConnection', payload)

    // redirect to home page
    this.$router.push({ path: '/' }) 
  }
}
</script>